import React from 'react';
// import { Helmet } from 'react-helmet';
import { Helmet } from 'react-helmet-async';

const Metatags = ({ 
  title = "GarageXY - Find Affordable Parking", 
  description = "Discover affordable parking spaces and garages near you", 
  keywords = "parking, garage rental, affordable parking, find garage, parking spaces",
  image, url 
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Add Open Graph tags for social sharing */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      <meta property="og:type" content="website" />
    </Helmet>
  );
};

export default Metatags;
